/* @flow */

import * as React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import FlexBox from '../../FlexBox';
import Icon from '../../Icon';
import withi18n from '../../../utils/withI18n';
import { getLabel } from '../../../utils/i18n';
import KYC from './KYC';
import UserAvatar from './UserAvatar';
import KYCEntryWithout2FA from './KYCEntryWithout2FA';

const UserInfoBox = styled(FlexBox)`
  min-height: 50px;
  .email {
    font-size: 20px;
    color: #fff;
    margin-right: 10px;
    line-height: 100%;
    font-family: ${({ theme }) => theme.fontIBMSemiBold};
  }
`;

const VipBox = styled(FlexBox)`
  font-size: ${({ theme }) => theme.fontSizeMd};
  color: ${({ theme }) => theme.highlight};
  line-height: 24px;
  .iconfont {
    margin-right: 6px;
  }
`;

const VerifyBtn = styled.span`
    font-size: ${({ theme }) => theme.fontSizeSm};
    color: ${({ theme }) => theme.highlight};
    display: inline-block;
    transition: all 0.3s ease-in-out;
    border: 1px solid ${({ theme }) => theme.highlight};
    height: 24px;
    line-height: 23px;
    padding: 0 10px;
    border-radius: 2px;
    margin-left: 10px;
    cursor: pointer;
`;

const mapStateToProps = ({ userInfo, locale, userKYCInfo }) => ({ userInfo, locale, userKYCInfo });

type UserInfo = {
  email: string,
  level: number,
  idPhoto: string,
  authenticationType: number,
  tradeLevel: number,
  isSubUser: boolean,
  mobileSecurity: boolean,
  gauth: boolean,
};

type Props = {
  i18n: Object,
  userInfo: UserInfo,
  direction: string,
  locale: string,
  userKYCInfo: Object,
};

export default
@withi18n
@connect(mapStateToProps)
class UserBaseInfo extends React.PureComponent<Props> {
  static defaultProps = {
    i18n: {},
    locale: 'en',
    direction: 'row',
    userInfo: {
      email: '',
      level: 0,
      tradeLevel: 0,
      authenticationType: 0,
      idPhoto: '-1',
      isSubUser: false,
      mobileSecurity: false,
      gauth: false,
    },
    userKYCInfo: {},
  };

  _renderKYC = () => {
    const {
      i18n,
      locale,
      userInfo: {
        mobileSecurity, gauth, isSubUser, authenticationType,
      },
      userKYCInfo,
    } = this.props;
    if (isSubUser) return null;
    if (!mobileSecurity && !gauth && userKYCInfo.kycStatus === -1) {
      return (
        <KYCEntryWithout2FA
          i18n={i18n}
          locale={locale}
          element={<VerifyBtn>{getLabel('exchange-nav-verify', i18n)}</VerifyBtn>}
        />
      );
    }
    return <KYC i18n={i18n} locale={locale} authenticationType={authenticationType} userKYCInfo={userKYCInfo} />;
  }

  render() {
    const {
      direction,
      userInfo: {
        email, tradeLevel,
      },
    } = this.props;
    if (!email) return <UserInfoBox />;
    // $FlowFixMe
    const emailPrefix = email ?.substr(0, 2);
    // $FlowFixMe
    const emailSuffix = email ?.split('@')[1];
    return (
      <UserInfoBox align="center" wrap="nowrap">
        <FlexBox margin="0 20px 0 0">
          <UserAvatar text={emailPrefix} />
        </FlexBox>
        <FlexBox direction={direction} align="center">
          <span className="email" title={email}>{`${emailPrefix}***@${emailSuffix}`}</span>

          <FlexBox align="center">
            <VipBox>
              <Icon type="vip" size={16} color="#f0b90b" />
              {` VIP ${tradeLevel}`}
            </VipBox>
            {this._renderKYC()}
          </FlexBox>
        </FlexBox>
      </UserInfoBox>
    );
  }
}
